import { createContext, useContext, useEffect, useState } from "react";
import api from './api';
import LogoImage from 'url:./images/logo@2x.png';
import {Helmet} from 'react-helmet';
import config from './config';
import { css } from "@emotion/react";
import theme from "./theme";
const {siteName} = config;

export const ShutdownContext = createContext();

export const ShutdownProvider = ({children}) => {
  const [shutdown, setShutdown] = useState(false);
  const [panic, setPanic] = useState();

  const check = async () => {
    try {
      const status = (await api.get('/status')).data;
      if (status.closed) setShutdown(true);
    } catch(err) {
      if (err.code == 503) setShutdown(true);
      else setPanic(err);
    }
  };

  useEffect(() => {
    check();
  }, []);

  if (panic) throw panic;

  return <ShutdownContext.Provider value={check}>{shutdown ? <ShutdownPage /> : children}</ShutdownContext.Provider>
};

export const useCheckShutdown = () => useContext(ShutdownContext);

export const ShutdownPage = () => {
  return (
    <div css={css`
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      max-width: 640px;
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    `}>
      <Helmet>
        <title>メンテナンス中 | {siteName}</title>
      </Helmet>
      <div css={css`text-align: center; margin: 0 0 48px;`}><img src={LogoImage} css={css`max-width: 100%; width: 247.29px;`}/></div>
      <p css={css`font-size: 32px; text-align: center`}>現在メンテナンス中です</p>
      <p css={css`margin-top: 48px`}>詳しくは<a href="https://musasisakai-ds.co.jp/" target="_blank" css={css`color: ${theme.colors.primary}`}>こちら</a>から教習所のお知らせページをご確認ください</p>
    </div>
  );
};
